import React, {Component, PropTypes} from 'react'
import classNames from 'classnames'
import ga from 'react-ga'
import {CargoType} from 'types'
import GeneralStore from 'stores/GeneralStore'
import CategoryStore from 'stores/CategoryStore'
import CargosStore from 'stores/CargosStore'
import EditingCargoStore from 'stores/EditingCargoStore'
import ActionCreators from 'actions/ActionCreators'
import Subcategories from 'components/Subcategories'
import Cargos from 'components/Cargos'
import ButtonControl from 'components/ButtonControl'
import IconControl from 'components/IconControl'
import SelectedCategory from 'components/SelectedCategory'
import MobileBackButton from 'components/MobileBackButton'
import ProgressBarPane from 'components/ProgressBarPane'
import TotalMeasurementsPaneControl from 'components/TotalMeasurementsPaneControl'
import PureRenderMixin from 'react-addons-pure-render-mixin'
import {translate as t} from 'lang'
import {dumpState} from 'api'
import { withRouter } from 'react-router'

import './CargosScreen.scss';

function getStateFromStores() {
    return {
        selectedCategory: CategoryStore.getSelected(),
        allCargos: CargosStore.getAllCargos(),
        cargos: CargosStore.getDeliveryCargos(),
        isCargoTypesShown: CargosStore.isCargoTypesShown(),
        isEditMode: GeneralStore.isEditMode(),
    };
}

/**
 * Экран со списком доступных грузов.
 */
class CargosScreen extends Component {
    
    static propTypes = {
        cargos: PropTypes.objectOf(CargoType),
    }
    
    constructor(props) {
        super(props);
        
        const storesState = getStateFromStores();
        const defaultCargo = CargosStore.creteCargoTypeByCategory(storesState.selectedCategory.id);
        
        this.state = {
            ...storesState,
            defaultCargo: defaultCargo,
            showCargosContainer: false,
        }
    }
    
    componentWillMount() {
        this._checkCategory();
        
        if (this.state.selectedCategory.name === 'book_separate_car') {
            ActionCreators.addSubcategory();
        }
    }
    
    componentDidMount() {
        GeneralStore.addChangeListener(this._onChange)
        CategoryStore.addChangeListener(this._onChange)
        CargosStore.addChangeListener(this._onChange)
        EditingCargoStore.addChangeListener(this._onChange)
    
        this.props.router.setRouteLeaveHook(this.props.route, (nextLocation) => {
            if (this.state.cargos && this.state.cargos.size > 0 && nextLocation && nextLocation.pathname === '/') {
                return t('WARNING_RETURN_TO_CATEGORY_SELECTION')
            }
        })
    }
    
    componentWillUnmount() {
        GeneralStore.removeChangeListener(this._onChange);
        CategoryStore.removeChangeListener(this._onChange);
        CargosStore.removeChangeListener(this._onChange);
        EditingCargoStore.removeChangeListener(this._onChange);
    }
    
    shouldComponentUpdate() {
        if (EditingCargoStore.isEditing()) {
            return false;
        }
        
        return PureRenderMixin.shouldComponentUpdate.call(this);
    }
    
    _onChange = () => {
        this.setState(getStateFromStores());
    }
    
    _onCargoFinish = () => {
        const categoryId = this.props.params.categoryId;
        const stage = `/category/${categoryId}/route`;
        
        ActionCreators.cancelTankmenValidation();
        ActionCreators.setStage(stage, this.props.location.query);
        
        ga.event({
            category: 'orders',
            action: 'add_orders_new_s2',
            label: categoryId,
        });
    }
    
    _onBackClick = () => {
        ga.event({
            category: 'buttons',
            action: 'click_button_return_s1_booking_step_2',
            label: this.state.selectedCategory.name,
            value: 1,
        })
    
        ActionCreators.setStage('/', this.props.location.query)
    }
    
    _checkCategory = () => {
        if (this.state.allCargos.length === 0 && this.state.cargos.size === 0) {
            this.setState({showCargosContainer: true});
            ActionCreators.addCargo(this.state.defaultCargo);
        }
    }
    
    _clickMobileBackButton = (stage) => {
        ga.event({
            category: 'buttons',
            action: 'click_button_booking_step_2',
            label: 'return_s1',
            value: 1,
        })
        
        ActionCreators.setStage('/', this.props.location.query)
    }
    
    _onEditComplete = () => {
        if (confirm(t('EDIT_ORDER_WARNING'))) {
            ActionCreators.showLoadingOverlay();
            ActionCreators.cancelTankmenValidation();
            
            ActionCreators.submitUpdate()
            .catch(error => {
                ActionCreators.hideLoadingOverlay();
                
                if (error === false) {
                    dumpState();
                    alert(t('SOMETHING_WENT_WRONG'));
                } else if (typeof error === 'string') {
                    alert(t(error));
                }
            });
        }
    }
    
    _renderCargosContainer = () => {
        if ((this.state.cargos.size
            || this.state.showCargosContainer
            || (this.state.isEditMode && this.state.allCargos.length === 0 && this.state.cargos.size === 0)
        ) && this.state.selectedCategory.name !== 'book_separate_car') {
            return (
                <Cargos cargos={this.state.cargos}
                        hasEditingCargo={this.state.isCargoTypesShown && this.state.allCargos.length > 0}
                        catergoryCargos={this.state.allCargos}
                        defaultCargo={this.state.defaultCargo}
                        selectedCategory={this.state.selectedCategory}/>
            )
        } else {
            return null;
        }
    }
    
    _renderSubcategories = () => {
        if ((this.state.isCargoTypesShown || (this.state.cargos.size === 0 && this.state.allCargos.length > 0))
            && !this.state.showCargosContainer) {
            return (
                <div>
                    <SelectedCategory category={this.state.selectedCategory}/>
                    <Subcategories
                        cargos={this.state.allCargos}
                        selectedCategory={this.state.selectedCategory}
                        deliveryCargos={this.state.cargos}
                        onCargoFinish={this._onCargoFinish}/>
                </div>
            );
        } else {
            return null;
        }
    }
    
    _renderTotalMeasurements = () => {
        if (this.state.selectedCategory.name === 'book_separate_car') {
            return (<TotalMeasurementsPaneControl selectedCategory={this.state.selectedCategory}/>);
        } else {
            return null;
        }
    }
    
    _returnTextAboveButtons = () => {
        if (this.state.selectedCategory.name === 'book_separate_car') {
            return ('Если вы закончили выбор грузовика, переходите на следующий шаг.')
        } else {
            return ('Если вы закончили добавление грузов, переходите на следующий шаг.');
        }
    }
    
    render() {
        const cargosContainer = this._renderCargosContainer();
        const subcategories = this._renderSubcategories();
        
        const textAboveButtons = this._returnTextAboveButtons();
        const textAboveButtonsClass = classNames([
            'CargosScreen-description',
            {
                '-active': this.state.cargos.size > 0,
            },
        ]);
        
        const totalMeasurementsBlock = this._renderTotalMeasurements();
        
        return (
            <div>
                <div className="CargosScreen-MobileBackButton">
                    <span className="CargosScreen-MobileBackButtonLabel">Выбранная категория</span>
                    {!this.state.isEditMode ?
                        <MobileBackButton label={this.state.selectedCategory.get('title')}
                                          address={'/'}
                                          onClick={this._clickMobileBackButton}/> :
                        <div className="CargosScreen-MobileTitle">
                            {this.state.selectedCategory.get('title')}
                        </div>
                    }
                </div>
                <div className="CargosScreen container">
                    {cargosContainer}
                    {subcategories}
                    {totalMeasurementsBlock}
                    <div className={textAboveButtonsClass}>{textAboveButtons}</div>
                    {this.state.isEditMode ?
                        <div className="CargosScreen-buttons">
                            <ButtonControl className="CargosScreen-next"
                                           id="next_step"
                                           view="sand"
                                           size="m"
                                           shadow={false}
                                           disabled={this.state.cargos.size === 0}
                                           rightIcon={<IconControl name="rightArrow"/>}
                                           onClick={this._onCargoFinish}>
                                {t('NEXT_STEP')}
                            </ButtonControl>
                            <ButtonControl
                                className="CargosScreen-submitUpdate"
                                view="forest"
                                size="m"
                                disabled={this.state.cargos.size === 0}
                                onClick={this._onEditComplete}>
                                {t('SAVE')}
                            </ButtonControl>
                        </div>
                        :
                        <div className="CargosScreen-buttons">
                            <ButtonControl
                                className="CargosScreen-back"
                                view="stone"
                                size="s"
                                leftIcon={<IconControl name="leftArrow"/>}
                                onClick={this._onBackClick}>
                                {t('BACK')}
                            </ButtonControl>
                            <ButtonControl className="CargosScreen-next"
                                           id="next_step"
                                           view="sand"
                                           size="m"
                                           shadow={false}
                                           disabled={this.state.cargos.size === 0}
                                           rightIcon={<IconControl name="rightArrow"/>}
                                           onClick={this._onCargoFinish}>
                                {t('NEXT_STEP')}
                            </ButtonControl>
                        </div>
                    }
                    
                    <ProgressBarPane locations={this.props.location}/>
                </div>
            </div>
        );
    }
    
}

export default withRouter(CargosScreen)



// WEBPACK FOOTER //
// ./client/components/CargosScreen/CargosScreen.js